export default __webpack_public_path__ + "static/media/backIcon.b2518e9d.svg";